import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import css from './Topbar.module.css';

const SearchIcon = props => {
  const { className, rootClassName } = props;
  const classes = classNames(rootClassName || css.rootSearchIcon, className);

  return (
    <svg
      className={classes}
      width="16"
      height="16"
      viewBox="0 0 28 28"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="m19.613 18.21.094.083 8 8a1 1 0 0 1-1.32 1.497l-.094-.083-8-8a1 1 0 0 1 1.32-1.497M9.5 0a9.5 9.5 0 1 1 0 19 9.5 9.5 0 0 1 0-19m0 2a7.5 7.5 0 1 0 0 15 7.5 7.5 0 0 0 0-15" />
    </svg>
  );
};

const { string } = PropTypes;

SearchIcon.defaultProps = {
  className: null,
  rootClassName: null,
};

SearchIcon.propTypes = {
  className: string,
  rootClassName: string,
};

export default SearchIcon;
